import { PanelBoxV2 } from "@/tpo/Boxes";
import Center from "@/tpo/Center";
import ChevronComponent from "@/tpo/Chevron";
import ButtonV2 from "@/v2/Buttons";

import Box from "./Box";
import DataLoader from "./DataLoader";
import { DownloadCrossOriginFile } from "./Links";

export default function LabReports({ query, userTest, userId, organisationId, variables }) {
  return (
    <PanelBoxV2 maxWidth={1020} stacked gap={20}>
      <PanelBoxV2
        maxWidth={760}
        outer={{
          pt: [30, 30, 60],
          pb: [30, 30, 80],
          bg: "white",
          borderRadius: 5,
          px: [20]
        }}
        stacked
        gap={[10, 10, 20]}
      >
        <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
          Lab Reports
        </Box>
        {userTest && (
          <DataLoader
            query={query}
            variables={{
              userTestId: userTest.id,
              userId,
              ...variables
            }}
            render={({ userTest: { dataFiles, generatedPdf } }) => {
              if (dataFiles.length || generatedPdf) {
                return (
                  <>
                    <Box display="flex" flexDirection="column" gap={[20, 10]}>
                      {dataFiles
                        .filter(userTestDataFile => userTestDataFile.dataFileUrl)
                        .map(userTestDataFile => {
                          let fileUrl = userTestDataFile.dataFileUrl;

                          if (userId && organisationId) {
                            // patient view
                            fileUrl = `${userTestDataFile.dataFileUrl}?user_id=${userId}&organisation_id=${organisationId}`;
                          } else if (userId) {
                            // guardian view
                            fileUrl = `${userTestDataFile.dataFileUrl}?user_id=${userId}`;
                          }

                          return (
                            <Box
                              display="flex"
                              flexDirection={["column", "row"]}
                              justifyContent={[null, "space-between"]}
                              gap={[10, null, null]}
                              key={userTestDataFile.id}
                            >
                              <Center
                                fontFamily="gilroyBold"
                                fontSize={[14, 16, 16]}
                                justifyContent={["flex-start", "flex-start", "center"]}
                              >
                                {userTestDataFile.name}
                              </Center>
                              <DownloadCrossOriginFile
                                redirect
                                fileUrl={fileUrl}
                                fileName={`${userTestDataFile.name}.${
                                  userTestDataFile?.testDataFile?.fileType?.extension || "pdf"
                                }`}
                                contentType={
                                  userTestDataFile?.testDataFile?.fileType?.contentType ||
                                  "application/pdf"
                                }
                                trigger={
                                  <Box display="flex">
                                    <ButtonV2
                                      color="green"
                                      rightIcon={<ChevronComponent direction="bottom" />}
                                      size={["sm", "sm", "md"]}
                                    >
                                      Download
                                    </ButtonV2>
                                  </Box>
                                }
                              />
                            </Box>
                          );
                        })}
                      {generatedPdf && (
                        <Box
                          display="flex"
                          flexDirection={["column", "row"]}
                          justifyContent={[null, "space-between"]}
                          gap={[10, null, null]}
                        >
                          <Center
                            fontFamily="gilroyBold"
                            fontSize={[14, 16, 16]}
                            justifyContent={["flex-start", "flex-start", "center"]}
                          >
                            {generatedPdf.name}
                          </Center>
                          <DownloadCrossOriginFile
                            trigger={
                              <Box display="flex">
                                <ButtonV2
                                  color="green"
                                  rightIcon={<ChevronComponent direction="bottom" />}
                                  size={["sm", "sm", "md"]}
                                >
                                  Download
                                </ButtonV2>
                              </Box>
                            }
                            fileUrl={
                              userId && organisationId
                                ? `${generatedPdf.pdfFile}?user_id=${userId}&organisation_id=${organisationId}`
                                : userId
                                ? `${generatedPdf.pdfFile}?user_id=${userId}`
                                : `${generatedPdf.pdfFile}`
                            }
                            fileName={`generated_biomarker_report_${generatedPdf.userTest.id}.pdf`}
                            contentType="application/pdf"
                            redirect
                          />
                        </Box>
                      )}
                    </Box>
                  </>
                );
              }

              return (
                <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
                  No reports available at this time
                </Box>
              );
            }}
          />
        )}
      </PanelBoxV2>
    </PanelBoxV2>
  );
}
